export const COURSE_TYPE = {
    VIDEO: 'VIDEO',
    BOOKING: 'BOOKING',
}

export const COURSE_CATEGORIES = {
    ALL: {
        label: 'COMMON_ITEMS.COURSE_CATALOG.ALL',
        code: 'ALL',
    },
}

export const COURSE_CATEGORY = {
    ALL: 'ALL',
    BEGINNER: 'BEGINNER',
    ELEMENTARY: 'ELEMENTARY',
    INTERMEDIATE: 'INTERMEDIATE',
    ADVANCED: 'ADVANCED',
    NATIVE: 'NATIVE',
    CONVERSATION: 'CONVERSATION',
}